import "./ToastCancelCharging.css";
import Button from "../button/Button";
import Modal from "../modal/Modal";

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorCancelCharging: React.Dispatch<React.SetStateAction<string>>;
  allowButtonClosed: boolean;
  handleCancelCharging: () => void;
  isLoading?: boolean;
  errorStopCharging?: string;
}

const ToastCancelCharging: React.FC<Props> = ({isModalOpen, errorStopCharging, setErrorCancelCharging, isLoading, setIsModalOpen, allowButtonClosed, handleCancelCharging}) => {
  return (
    <>
      <Modal 
        title="Deseja cancelar?"
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
          setErrorCancelCharging('')
        }}
        textEnterButton="Cancelar recarga"
        handleEnterButton={handleCancelCharging}
        isLoadingEnterButton={isLoading}
      >
        <div className="toast-stop-charging-modal-container">
          <p className="toast-stop-charging-modal-text">
            Seu carro ainda não está com a carga completa.
          </p>
          {errorStopCharging && <p className="toast-stop-charging-modal-text-error">
            {errorStopCharging}
          </p>}
        </div>
      </Modal>
    </>
  );
};

export default ToastCancelCharging;
